"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    CarouselSlideWidthOptions: ()=>CarouselSlideWidthOptions,
    CarouselImageSlideWidthOptions: ()=>CarouselImageSlideWidthOptions,
    carouselVariants: ()=>carouselVariants,
    CarouselPaginationOptions: ()=>CarouselPaginationOptions,
    CarouselNumSlidesOptions: ()=>CarouselNumSlidesOptions,
    CarouselAutoplayOptions: ()=>CarouselAutoplayOptions,
    CarouselHideArrowsOnMobileOrTouchOptions: ()=>CarouselHideArrowsOnMobileOrTouchOptions,
    CarouselTypeOptions: ()=>CarouselTypeOptions,
    CarouselContentSlideWidthOptions: ()=>CarouselContentSlideWidthOptions,
    CarouselRoundedOptions: ()=>CarouselRoundedOptions
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const carouselVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        rootSlot: 'relative mx-auto w-full',
        viewportSlot: 'overflow-hidden',
        containerSlot: 'pan-y pinch-zoom relative flex',
        slideSlot: '',
        controlsSlot: 'absolute inset-0',
        buttonsSlot: 'absolute inset-y-0 left-0 right-0 flex items-center justify-between px-4',
        buttonSlot: 'pointer-events-auto m-0 inline-flex items-center justify-center rounded-full border-0 p-0',
        hiddenButtonSlot: 'invisible m-0 inline-flex items-center justify-center rounded-full border-0 p-0',
        dotsPaginationSlot: 'absolute bottom-4 left-0 right-0 flex items-center justify-center',
        dotButtonSlot: 'pointer-events-auto inline-flex h-7 w-7 cursor-pointer items-center justify-center',
        dotSlot: 'border-neutral-1 bg-neutral-12/10 h-2 w-2 rounded-full border',
        dotSelectedSlot: 'bg-neutral-1 h-3 w-3'
    },
    variants: {
        type: {
            image: {},
            content: {}
        },
        numSlides: {
            1: {},
            2: {},
            3: {}
        },
        slideGap: {
            3: {}
        },
        rounded: {
            'top-left': {
                viewportSlot: 'rounded-tl-lg'
            },
            top: {
                viewportSlot: 'rounded-t-lg'
            },
            left: {
                viewportSlot: 'rounded-l-lg'
            },
            all: {
                viewportSlot: 'rounded-lg'
            },
            none: {}
        },
        slideWidth: {
            min: {
                containerSlot: 'pan-y pinch-zoom relative flex gap-3',
                slideSlot: 'min-w-64'
            },
            auto: {
                containerSlot: 'pan-y pinch-zoom relative flex gap-3',
                slideSlot: 'min-w-0 flex-shrink-0 flex-grow-0'
            },
            same: {
                containerSlot: 'pan-y pinch-zoom relative flex gap-3',
                rootSlot: '@container relative mx-auto',
                slideSlot: 'flex-shrink-0 flex-grow-0'
            },
            image: {
                slideSlot: 'min-w-0 flex-shrink-0 flex-grow-0 basis-full'
            }
        },
        isDotSelected: {
            true: {
                dotSlot: 'bg-neutral-1 h-3 w-3'
            },
            false: {
                dotSlot: 'bg-neutral-12/10 border-neutral-1 h-2 w-2'
            }
        },
        loop: {
            true: {},
            false: {}
        },
        hideArrowsOnMobileOrTouch: {
            responsive: {},
            always: {},
            never: {}
        },
        fullBleedOnMobile: {
            true: {},
            false: {}
        }
    },
    compoundVariants: [
        {
            hideArrowsOnMobileOrTouch: 'responsive',
            class: {
                buttonsSlot: 'pointer-events-none absolute inset-y-0 left-0 right-0 hidden items-center justify-between px-4 sm:flex'
            }
        },
        {
            hideArrowsOnMobileOrTouch: 'always',
            class: {
                buttonsSlot: 'pointer-events-none absolute inset-y-0 left-0 right-0 hidden items-center justify-between px-4'
            }
        },
        {
            hideArrowsOnMobileOrTouch: 'never',
            class: {
                buttonsSlot: 'pointer-events-none absolute inset-y-0 left-0 right-0 flex items-center justify-between px-4'
            }
        },
        {
            fullBleedOnMobile: true,
            slideWidth: 'min',
            class: {
                rootSlot: 'ml-[calc(50%-50vw)] w-screen sm:ml-0 sm:w-full'
            }
        },
        {
            fullBleedOnMobile: true,
            slideWidth: 'auto',
            class: {
                rootSlot: 'ml-[calc(50%-50vw)] w-screen sm:ml-0 sm:w-full'
            }
        },
        {
            fullBleedOnMobile: true,
            slideWidth: 'same',
            class: {
                rootSlot: 'ml-[calc(50%-50vw)] w-screen sm:ml-0 sm:w-full'
            }
        },
        {
            slideWidth: 'same',
            numSlides: '1',
            slideGap: '3',
            class: {
                slideSlot: '@3xl:w-[calc((100cqw-100px)/2)] @7xl:w-[calc((100cqw-100px)/3)] w-[calc((100cqw-100px))]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: '2',
            slideGap: '3',
            class: {
                slideSlot: '@3xl:w-[calc((100cqw-100px)/4)] @7xl:w-[calc((100cqw-100px)/6)] w-[calc((100cqw-100px)/2)]'
            }
        },
        {
            slideWidth: 'same',
            numSlides: '3',
            slideGap: '3',
            class: {
                slideSlot: '@3xl:w-[calc((100cqw-100px)/6)] @7xl:w-[calc((100cqw-100px)/9)] w-[calc((100cqw-100px)/3)]'
            }
        }
    ],
    defaultVariants: {
        type: 'content',
        numSlides: '1',
        rounded: 'all',
        slideGap: '3',
        slideWidth: 'auto',
        hideArrowsOnMobileOrTouch: 'responsive',
        fullBleedOnMobile: true
    }
});
const CarouselTypeOptions = [
    'image',
    'content'
];
const CarouselAutoplayOptions = [
    'hover',
    'inview',
    'init'
];
const CarouselPaginationOptions = [
    'numbers',
    'dots'
];
const CarouselRoundedOptions = Object.keys(carouselVariants.variants.rounded);
const CarouselSlideWidthOptions = Object.keys(carouselVariants.variants.slideWidth);
const CarouselImageSlideWidthOptions = Object.keys(carouselVariants.variants.slideWidth).filter((key)=>'image' === key);
const CarouselContentSlideWidthOptions = Object.keys(carouselVariants.variants.slideWidth).filter((key)=>'image' !== key);
const CarouselNumSlidesOptions = Object.keys(carouselVariants.variants.numSlides);
const CarouselHideArrowsOnMobileOrTouchOptions = Object.keys(carouselVariants.variants.hideArrowsOnMobileOrTouch);
exports.CarouselAutoplayOptions = __webpack_exports__.CarouselAutoplayOptions;
exports.CarouselContentSlideWidthOptions = __webpack_exports__.CarouselContentSlideWidthOptions;
exports.CarouselHideArrowsOnMobileOrTouchOptions = __webpack_exports__.CarouselHideArrowsOnMobileOrTouchOptions;
exports.CarouselImageSlideWidthOptions = __webpack_exports__.CarouselImageSlideWidthOptions;
exports.CarouselNumSlidesOptions = __webpack_exports__.CarouselNumSlidesOptions;
exports.CarouselPaginationOptions = __webpack_exports__.CarouselPaginationOptions;
exports.CarouselRoundedOptions = __webpack_exports__.CarouselRoundedOptions;
exports.CarouselSlideWidthOptions = __webpack_exports__.CarouselSlideWidthOptions;
exports.CarouselTypeOptions = __webpack_exports__.CarouselTypeOptions;
exports.carouselVariants = __webpack_exports__.carouselVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "CarouselAutoplayOptions",
    "CarouselContentSlideWidthOptions",
    "CarouselHideArrowsOnMobileOrTouchOptions",
    "CarouselImageSlideWidthOptions",
    "CarouselNumSlidesOptions",
    "CarouselPaginationOptions",
    "CarouselRoundedOptions",
    "CarouselSlideWidthOptions",
    "CarouselTypeOptions",
    "carouselVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
